module.exports = __webpack_public_path__ + "static/services-image-5_m-41673cc60bea21ece9cb4417e875a6c5.jpg";